import { FaFacebookF,FaTwitter,FaYoutube } from "react-icons/fa"


const Nav = () => {
  return (
      <>
          <nav className="wrapLogo navbar-fixed-top">
              <div className="container">
                  <div className="row">
                      <div className="col-xs-12">
                          <img src="images/logo-k4k-reviews.gif" className="logoHead" width="225" height="39"
                               alt="Kars4Kids Reviews Logo"/>
                          <div className="buttonWrap">
                              <span className="hidden-xs">Join our 500,000+ donors</span> <a
                              href="https://www.kars4kids.org" className="donateButton">Donate a car</a>
                          </div>
                      </div>
                  </div>
              </div>
          </nav>

          <section className="wrapMain" style={{backgroundImage: "url('/images/hp-bg-road2.gif')"}}>
              <img src="images/pin1.png" width="154" height="81"  className="pinCar pinCar1"
                   style={{ animationDelay: '11s' }}/>
              <img src="images/pin2.png" width="154" height="81"  className="pinCar pinCar2"
                   style={{ animationDelay: '9s' }}/>
              <img src="images/pin3.png" width="154" height="81"  className="pinCar pinCar3 hidden-xs"
                   style={{ animationDelay: '5s' }}/>
              <img src="images/pin4.png" width="154" height="81"  className="pinCar pinCar4"
                   style={{ animationDelay: '0s' }}/>
              <img src="images/pin5.png" width="154" height="81"  className="pinCar pinCar5"
                   style={{ animationDelay: '2s' }}/>
              <img src="images/pin6.png" width="154" height="81"  className="pinCar pinCar6 hidden-xs"
                   style={{ animationDelay: '1s' }}/>
              <img src="images/pin7.png" width="154" height="81"  className="pinCar pinCar7 hidden-xs hidden-sm"
                   style={{ animationDelay: '8s' }}/>
              <img src="images/pin8.png" width="154" height="81"  className="pinCar pinCar8 hidden-xs hidden-sm"
                   style={{ animationDelay: '9s' }}/>


              <div className="container">
                  <div className="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 text-center">
                      <h1> 20K+ reviews, <br className="hidden-xs"/><span
                          id="h1span">from real donors.</span>
                      </h1>
                      <p>We’ve compiled 1,000’s of our donors reviews from across the web, and we’re delighted to share
                          their feedback.</p>
                  </div>
              </div>
          </section>

          <section className="reviewLogos">
              <div className="container">
                  <div className="col-xs-12 text-center">
                      <ul className="logoUl">
                          <li><img src="/images/logo1.png" width="108" height="43" alt="Google logo"
                                   className="img-responsive otherLogo"/></li>
                          <li><img src="/images/logo2.png" width="161" height="43"
                                   className="img-responsive trustpilotLogo" alt="truspilot logo"/></li>
                          <li><img src="/images/logo3.png" width="114" height="43" className="img-responsive otherLogo"
                                   alt="feefo logo"/></li>
                      </ul>


                  </div>
              </div>
          </section>
      </>
  )
}

const Footer = () => {
    return (

        <div id="footer">
            <div className="container">
                <div className="col-sm-4 col-sm-offset-4">
                    <ul className="nav navbar-nav footer-links text-center">
                        <li><a href="https://www.kars4kids.org">&copy; Kars4Kids</a></li>
                        {/* <li><a href="write-review.asp">Write a review</a></li> */}
                        <li><a href="https://www.kars4kids.org/contact-kars4kids.php">Contact Us</a></li>
                    </ul>

                    <ul className="nav nav-pills col-sm-12 ">
                        <li><a href="https://www.facebook.com/kars4kids"><FaFacebookF fontSize="2em"/></a></li>
                        <li><a href="https://twitter.com/Kars4kids"><FaTwitter fontSize="2em"/></a></li>
                        <li><a href="http://www.youtube.com/user/877kars4kids"><FaYoutube fontSize="2em"/></a></li>
                    </ul>
                </div>

            </div
            >
        </div>


    )
}


export {Nav, Footer}
